import React from 'react'

interface Props {
  color?: string
  text?: string
}

export const MenuTag: React.FC<Props> = ({ color, text }: Props) => {
  return (
    <span
      style={{
        position: 'relative',
        left: '3px',
        top: '-8px',
        color: color ? color : '#A5D6A7',
        fontSize: '12px',
      }}
    >
      {text}
    </span>
  )
}
